import {
  ChatFeedbackCreateInterface,
  ChatFeedbackInterface,
  FeedbackRepositoryInterface, TicketFeedbackCreateInterface, TicketFeedbackInterface,
} from '@/services/QC-V2/feedback/interfaces';
import { AxiosInstance } from 'axios';
import { FilterRequestData, ChatReviewFormDataInterface } from '@/services/QC-V2/chat/interfaces';
import { FeedbackStatus } from '@/services/QA/feedback/interfaces';
import { TicketReviewFormDataInterface } from '@/services/QC-V2/ticket/interfaces';

export default class FeedbackRepository implements FeedbackRepositoryInterface {
  constructor(
    private readonly axios: AxiosInstance,
  ) {
  }

  public async createChatFeedback(
    feedback: ChatFeedbackCreateInterface,
    review: ChatReviewFormDataInterface,
  ): Promise<void> {
    const response = await this.axios.post('/chat-controller-v2/feedbacks', { feedback, review });

    return response.data;
  }

  public async createTicketFeedback(
    feedback: TicketFeedbackCreateInterface,
    review: TicketReviewFormDataInterface,
  ): Promise<void> {
    const response = await this.axios.post('/ticket-controller-v2/feedbacks', { feedback, review });

    return response.data;
  }

  public async updateChatFeedback(id: number, review: ChatReviewFormDataInterface): Promise<void> {
    const response = await this.axios.patch(`/chat-controller-v2/feedbacks/${id}`, review);

    return response.data;
  }

  public async updateTicketFeedback(
    id: number,
    review: TicketReviewFormDataInterface,
  ): Promise<void> {
    const response = await this.axios.patch(`/ticket-controller-v2/feedbacks/${id}`, review);

    return response.data;
  }

  public async getAllChatFeedbacks(filterRequestData?: FilterRequestData): Promise<[ChatFeedbackInterface[], number]> {
    let url = '/chat-controller-v2/feedbacks?';
    if (filterRequestData) {
      const parameters = Object.keys(filterRequestData)
        .filter((key) => !key.startsWith('ticket') && !!filterRequestData[key])
        .map((key) => `${key}=${filterRequestData[key]}`);

      url = `${url}${parameters.join('&')}`;
    }

    const response = await this.axios.get(url);

    return response.data;
  }

  public async getChatFeedback(id: number): Promise<ChatFeedbackInterface> {
    const response = await this.axios.get(`/chat-controller-v2/feedbacks/${id}`);

    return response.data;
  }

  public async getAllTicketFeedbacks(
    filterRequestData?: FilterRequestData,
  ): Promise<[TicketFeedbackInterface[], number]> {
    let url = '/ticket-controller-v2/feedbacks?';
    if (filterRequestData) {
      const parameters = Object.keys(filterRequestData)
        .filter((key) => !key.startsWith('chat') && !!filterRequestData[key])
        .map((key) => `${key}=${filterRequestData[key]}`);

      url = `${url}${parameters.join('&')}`;
    }

    const response = await this.axios.get(url);

    return response.data;
  }

  public async getTicketFeedback(id: number): Promise<TicketFeedbackInterface> {
    const response = await this.axios.get(`/ticket-controller-v2/feedbacks/${id}`);

    return response.data;
  }

  public async changeChatFeedbackStatus(id: number, status: FeedbackStatus): Promise<void> {
    await this.axios.patch(`/chat-controller-v2/feedbacks/${id}/status`, { status });
  }

  public async changeTicketFeedbackStatus(id: number, status: FeedbackStatus): Promise<void> {
    await this.axios.patch(`/ticket-controller-v2/feedbacks/${id}/status`, { status });
  }
}
